import axios from "axios";
import store from "@/store"; // Import Vuex store
import router from "@/router"; // Pastikan konfigurasi router sudah benar

// Buat instance axios
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // Ganti dengan URL API Anda
});

// Tambahkan interceptor untuk menyisipkan user ke dalam body permintaan
apiClient.interceptors.request.use(
  (config) => {
    if (config.data instanceof FormData) {
      // Jangan set Content-Type ketika mengirimkan FormData, biarkan browser menanganinya
      delete config.headers["Content-Type"];
    } else {
      config.headers["Content-Type"] = "application/json"; // Default untuk JSON
    }
    return config;
  },
  (error) => {
    // Tangani error request
    // store.dispatch("hideLoading");
    return Promise.reject(error);
  },
);

// Tambahkan interceptor untuk menyisipkan JWT token
apiClient.interceptors.request.use(
  (config) => {
    // Ambil token dari localStorage
    // const token_jwt = localStorage.getItem("token_jwt");

    const token_jwt = store.getters["user/getJwtToken"];
    // console.log(token);
    // console.log(token_jwt);

    // Jika token_jwt ada, tambahkan ke header Authorization
    if (token_jwt) {
      config.headers.token_jwt = token_jwt;
    }

    return config;
  },
  (error) => {
    // Tangani error permintaan
    return Promise.reject(error);
  },
);

// Tambahkan interceptor respons untuk menangani token_jwt expired
apiClient.interceptors.response.use(
  (response) => {
    // Sembunyikan loading saat respons diterima
    // store.dispatch("hideLoading");
    return response;
  },
  (error) => {
    if (error.response) {
      // Cek apakah token_jwt expired (status code 401 atau 403)
      if (error.response.status === 401 || error.response.status === 403) {
        // Hapus token dari localStorage karena sudah tidak valid
        localStorage.removeItem("token_jwt");

        localStorage.removeItem("user"); // Ganti "my-vue-app" dengan key yang Anda gunakan di vuex-persistedstate

        // Arahkan pengguna ke halaman login
        router.push({ name: "login" }); // Ganti dengan rute login Anda
      }
    }

    return Promise.reject(error);
  },
);
// Export default axios instance
export default apiClient;
